import * as tslib_1 from "tslib";
import { Renderer2 } from "@angular/core";
import { environment } from "src/environments/environment";
import * as i0 from "@angular/core";
/** Captcha Service */
var CaptchaService = /** @class */ (function () {
    /** Method to initialize component */
    function CaptchaService() {
    }
    /**
     * Initiate script for captcha
     * @param _renderer Angular's Renderer2 instance used to interact with the DOM.
     */
    CaptchaService.prototype.initiateCaptchaScript = function (_renderer) {
        var isScriptAppended = !!document.getElementById('g-captcha');
        if (!isScriptAppended) {
            var script = _renderer.createElement("script");
            script.src = "https://www.google.com/recaptcha/api.js?render=" + environment.gcaptchaKey;
            script.id = "g-captcha";
            _renderer.appendChild(document.body, script);
        }
    };
    /**
     * Submit captcha and generate response
     * @returns {Promise<string>} Generated response string from captcha
     */
    CaptchaService.prototype.checkCaptcha = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (res, rej) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                        return tslib_1.__generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!(typeof grecaptcha === 'undefined')) return [3 /*break*/, 2];
                                    return [4 /*yield*/, new Promise(function (res, rej) {
                                            document.getElementById('g-captcha').onload = res;
                                        })];
                                case 1:
                                    _a.sent();
                                    _a.label = 2;
                                case 2:
                                    grecaptcha.ready(function () {
                                        return tslib_1.__awaiter(this, void 0, void 0, function () {
                                            var _a;
                                            return tslib_1.__generator(this, function (_b) {
                                                switch (_b.label) {
                                                    case 0:
                                                        _a = res;
                                                        return [4 /*yield*/, grecaptcha.execute("" + environment.gcaptchaKey, {
                                                                action: "submit",
                                                            })];
                                                    case 1:
                                                        _a.apply(void 0, [_b.sent()]);
                                                        return [2 /*return*/];
                                                }
                                            });
                                        });
                                    });
                                    return [2 /*return*/];
                            }
                        });
                    }); })];
            });
        });
    };
    /**
     * Remove captcha script
     * @param _renderer Angular's Renderer2 instance used to interact with the DOM.
   *
     */
    CaptchaService.prototype.removeCaptchaScript = function (_renderer) {
        var script = _renderer.selectRootElement("script#g-captcha");
        _renderer.removeChild(document.body, script);
    };
    CaptchaService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CaptchaService_Factory() { return new CaptchaService(); }, token: CaptchaService, providedIn: "root" });
    return CaptchaService;
}());
export { CaptchaService };
